import { useState } from "react";
import { Gift } from "lucide-react";

const SEGMENTS = [
  { label: "10 squat", color: "#D6AD62" },
  { label: "Mahnı oxu", color: "#6366F1" },
  { label: "Sual-cavab", color: "#F43F5E" },
  { label: "Hədiyyə", color: "#10B981" },
  { label: "Rəqs et", color: "#F59E0B" },
  { label: "Salam de", color: "#0EA5E9" },
];
const SEG = 360 / SEGMENTS.length;
const gradient = `conic-gradient(${SEGMENTS.map((s, i) => `${s.color} ${i * SEG}deg ${(i + 1) * SEG}deg`).join(",")})`;

export const WheelDemo = () => {
  const [rot, setRot] = useState(0);
  const [spinning, setSpinning] = useState(false);
  const [result, setResult] = useState(null);

  const spin = () => {
    if (spinning) return;
    const next = rot + 360 * 5 + Math.floor(Math.random() * 360);
    setRot(next);
    setSpinning(true);
    setResult(null);
    setTimeout(() => {
      const idx = Math.floor(((360 - (next % 360)) % 360) / SEG);
      setResult(SEGMENTS[idx].label);
      setSpinning(false);
    }, 3200);
  };

  return (
    <div className="flex flex-col items-center" data-testid="wheel-demo">
      <div className="relative h-56 w-56">
        <div className="absolute left-1/2 -top-1 -translate-x-1/2 z-10 w-0 h-0 border-l-[10px] border-r-[10px] border-t-[18px] border-l-transparent border-r-transparent border-t-white" />
        <div
          className="h-full w-full rounded-full border-4 border-white/20 relative"
          style={{ background: gradient, transform: `rotate(${rot}deg)`, transition: "transform 3.2s cubic-bezier(.17,.67,.21,1)" }}
        >
          {SEGMENTS.map((s, i) => (
            <span key={s.label} className="absolute left-1/2 top-1/2 text-[11px] font-bold text-[#111110] origin-left"
              style={{ transform: `rotate(${i * SEG + SEG / 2 - 90}deg) translateX(30px)` }}>{s.label}</span>
          ))}
          <span className="absolute inset-0 m-auto h-10 w-10 rounded-full bg-[#111110] border-2 border-white/30" />
        </div>
      </div>
      <div className="h-8 mt-4 font-display text-lg font-semibold text-[#F3D592]" data-testid="wheel-result">
        {result ? `Nəticə: ${result}` : spinning ? "Fırlanır..." : ""}
      </div>
      <button className="adv-btn mt-2" onClick={spin} disabled={spinning} data-testid="wheel-spin-btn">
        <Gift className="h-4 w-4" /> Hədiyyə göndər (Rose)
      </button>
    </div>
  );
};
